export { BankTransactionsView } from "../../components/bank-transactions/bank-transactions-view";
